import { RegisterPayload } from "../../../models/User";
import { getApiInstance } from "../../api";
import ApiClient from "../../apiClient";
import mutationWrapper from "../mutationWrapper";

export async function register(data: RegisterPayload) {
  const res = await ApiClient.post(`/Register`, data);
  return res.data;
}

export const useRegister = mutationWrapper(register);
